import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Grid from "@mui/material/Grid";
import { Text, Theme, Button, ContentBlock } from '@simplybenefits/sb-ui-library';
import * as dates from '@simplybenefits/sb-dates';
import { helpers } from '@simplybenefits/sb-utils';
import { styled } from '@mui/system';
import { getPdf } from '../../../actions/master.js';
import { connect } from 'react-redux';

const StyledHeaderBar = styled('div')(({ theme }) => ({
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    marginTop: 20,
    marginBottom: 10,
    padding: 8,
    backgroundColor: theme.palette.primary.main
}));

const StyledLine = styled('div')(({ theme }) => ({
    width: '98%',
    height: 2,
    opacity: 0.5,
    backgroundColor: theme.palette.primary.main,
    margin: "10px auto"
}));

class DivisionBreakdown extends Component {

    downloadAsoReport = async (asoReportID, selectedDivisionID, clientName, divisionTitle, timeStamp, groupNum, period, accountID) => {
        await this.props.dispatch(getPdf("AsoDivision", `Simply_Benefits_ASO_Report_${ dates.getLocalDisplay(this.props.date, 'MMMM_YYYY') }.pdf`, { asoReportID, selectedDivisionID, clientName, divisionTitle, timeStamp, groupNum, period, accountID }));
    };

    render() {
        const { data, divisionTitle, account, period, asoReportID, selectedDivisionID } = this.props;
        const styles = {
            block: {
                display: 'flex',
                flex: 1,
                flexDirection: 'column'
            },
            row: {
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                padding: "5px 30px 0 50px"
            },
            rowCondensed: {
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                padding: 8
            }
        };

        return (
            <ContentBlock>
                <Grid container alignItems="center" spacing={2}>
                    <Grid item xs={ 8 }>
                        <Text largest veryBold>ASO Reconciliation Summary</Text>
                    </Grid>
                    <Grid item xs={ 4 }>
                        <Grid container justifyContent="flex-end">
                            <Grid item>
                                <Button transparent
                                    onClick={() => this.downloadAsoReport(
                                        asoReportID, 
                                        selectedDivisionID, 
                                        this.props.clientName, 
                                        divisionTitle, 
                                        this.props.timeStamp, 
                                        account.meta.groupNum, 
                                        period, 
                                        account.meta.accountID
                                    )}
                                >
                                        Download Division Summary
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Text large>{ divisionTitle }</Text>

                <div style={ styles.block } >
                    <StyledHeaderBar>
                        <Text medium bold color={ Theme.colors.surface } customStyle={{ flex: 2 }} />
                        <Text medium bold color={ Theme.colors.surface } customStyle={{ flex: 1, textAlign: 'center' }}>Health</Text>
                        <Text medium bold color={ Theme.colors.surface } customStyle={{ flex: 1, textAlign: 'center' }}>Dental</Text>
                        <Text medium bold color={ Theme.colors.surface } customStyle={{ flex: 1, textAlign: 'center' }}>Total</Text>
                    </StyledHeaderBar>

                    <div style={ styles.rowCondensed }>
                        <Text mediumLarge bold customStyle={{ flex: 2 }}>Prior Balance</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>-</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>-</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.formatNumber(data.total.startingBalance) }</Text>
                    </div>

                    <div style={ styles.rowCondensed }>
                        <Text medium customStyle={{ flex: 2 }}>ASO Adjustments</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>-</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>-</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.formatNumber(data.total.asoAdjustments) }</Text>
                    </div>

                    
                    <div style={ styles.rowCondensed }>
                        <Text medium customStyle={{ flex: 2 }}>ASO Stop Loss Adjustments</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>-</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>-</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.formatNumber(data.total.asoStopLossAdjustments) }</Text>
                    </div>
                    

                    <div style={ styles.rowCondensed }>
                        <Text medium customStyle={{ flex: 2 }}>Number of Lives - Solo</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>-</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>-</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.numberWithCommas(data.total.numLives.solo) }</Text>
                    </div>

                    <div style={ styles.rowCondensed }>
                        <Text medium customStyle={{ flex: 2 }}>Number of Lives - Duo</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>-</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>-</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.numberWithCommas(data.total.numLives.duo) }</Text>
                    </div>

                    <div style={ styles.rowCondensed }>
                        <Text medium customStyle={{ flex: 2 }}>Number of Lives - Family</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>-</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>-</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.numberWithCommas(data.total.numLives.family) }</Text>
                    </div>

                    <StyledLine/>

                    <div style={ styles.rowCondensed }>
                        <Text mediumLarge bold customStyle={{ flex: 1 }}>Revenue</Text>
                    </div>

                    <div style={ styles.rowCondensed }>
                        <Text medium customStyle={{ flex: 2 }}>ASO Balance Adjustments</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>-</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>-</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.formatNumber(data.total.asoAdjustments) }</Text>
                    </div>

                  
                    <div style={ styles.rowCondensed }>
                        <Text medium customStyle={{ flex: 2 }}>ASO Stop Loss Adjustments</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>-</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>-</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.formatNumber(data.total.asoStopLossAdjustments) }</Text>
                    </div>
                    

                    <div style={ styles.rowCondensed }>
                        <Text medium customStyle={{ flex: 2 }}>Benefit Adjustments</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.formatNumber(data.health.adjustments) }</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.formatNumber(data.dental.adjustments) }</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.formatNumber(data.total.adjustments) }</Text>
                    </div>

                    <div style={ styles.rowCondensed }>
                        <Text medium customStyle={{ flex: 2 }}>Net Premium Billed</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.formatNumber(data.health.netPremium) }</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.formatNumber(data.dental.netPremium) }</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.formatNumber(data.total.netPremium) }</Text>
                    </div>

                    <div style={ styles.rowCondensed }>
                        <Text medium customStyle={{ flex: 2 }}>Gross Premium Billed</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.formatNumber(data.health.grossPremium) }</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.formatNumber(data.dental.grossPremium) }</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.formatNumber(data.total.grossPremium) }</Text>
                    </div>

                    <StyledLine/>

                    <div style={ styles.rowCondensed }>
                        <Text mediumLarge bold customStyle={{ flex: 1 }}>Expenses</Text>
                    </div>

                    <div style={ styles.rowCondensed }>
                        <Text medium customStyle={{ flex: 2 }}>Claims Paid Under ASO</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.formatNumber(data.health.claimsPaid) }</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.formatNumber(data.dental.claimsPaid) }</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.formatNumber(data.total.claimsPaid) }</Text>
                    </div>

                    <div style={ styles.rowCondensed }>
                        <Text medium customStyle={{ flex: 2 }}>Management Fee</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.formatNumber(data.health.managementFee) }</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.formatNumber(data.dental.managementFee) }</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.formatNumber(data.total.managementFee) }</Text>
                    </div>

                    <div style={ styles.rowCondensed }>
                        <Text medium customStyle={{ flex: 2 }}>Administration Fee</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.formatNumber(data.health.adminFee) }</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.formatNumber(data.dental.adminFee) }</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.formatNumber(data.total.adminFee) }</Text>
                    </div>

                    <div style={ styles.rowCondensed }>
                        <Text medium customStyle={{ flex: 2 }}>Applicable Taxes</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.formatNumber(data.health.GST + data.health.PST + (data.health.RST || 0) + data.health.HST) }</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.formatNumber(data.dental.GST + data.dental.PST + (data.dental.RST || 0) + data.dental.HST) }</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.formatNumber(data.total.GST + data.total.PST + (data.total.RST || 0) + data.total.HST) }</Text>
                    </div>

                    <StyledLine />

                    <div style={ styles.rowCondensed }>
                        <Text mediumLarge bold customStyle={{ flex: 2 }}>Total Expenses</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.formatNumber(data.health.claimsPaid + data.health.managementFee + data.health.adminFee + data.health.GST + data.health.PST + (data.health.RST || 0) + data.health.HST) }</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.formatNumber(data.dental.claimsPaid + data.dental.managementFee + data.dental.adminFee + data.dental.GST + data.dental.PST + (data.dental.RST || 0) + data.dental.HST) }</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.formatNumber(data.total.claimsPaid + data.total.managementFee + data.total.adminFee + data.total.GST + data.total.PST + (data.total.RST || 0) + data.total.HST) }</Text>
                    </div>

                    <StyledLine />

                    <div style={ styles.rowCondensed }>
                        <Text medium customStyle={{ flex: 2 }}>Gains/Loss for Period</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>-</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>-</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.formatNumber(data.total.closingBalance - data.total.startingBalance) }</Text>
                    </div>

                    <StyledLine/>

                    <div style={ styles.rowCondensed }>
                        <Text mediumLarge bold customStyle={{ flex: 2 }}>Balance in ASO Account</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>-</Text>
                        <Text medium customStyle={{ flex: 1, textAlign: 'center' }}>-</Text>
                        <Text mediumLarge bold customStyle={{ flex: 1, textAlign: 'center' }}>{ helpers.formatNumber(data.total.closingBalance) }</Text>
                    </div>

                    <ul>
                        <li>{ `Management Fee - Dental ${ data.dental.managementFeePercentage }%` }</li>
                        <li>{ `Management Fee - Health ${ data.health.managementFeePercentage }%` }</li>
                        <li>{ `Administration Fee - Dental ${ data.dental.adminFeePercentage }%` }</li>
                        <li>{ `Administration Fee - Health ${ data.health.adminFeePercentage }%` }</li>
                        <li>{ `HST/GST #76557 5311`}</li>
                        <li>Balance in ASO Account assumes the Net Premium Billed has been paid in full.</li>
                    </ul>
                </div>

                <span id="aso-report" />
            </ContentBlock>
        );
    }
}

DivisionBreakdown.propTypes = {
    report: PropTypes.object
};

export default connect()(DivisionBreakdown);